export default __webpack_public_path__ + "static/media/learn-more-card-1.057582fb.svg";